webpackJsonp([48426709990240],{

/***/ 1084:
/***/ (function(module, exports) {

	module.exports = {"data":{"contributionsJson":{"name":"jah","www_url":"http://www.i-love-u.ch","thema":"endstation","issue_month":"August","issue_year":2008,"issue_date":200808,"artist":"admin","location":"Switzerland","email":"response@i-love-u.ch","id":"contribution_430","media_type":"still_image","position_in_section":32,"media_uri":"media/2008/August/still_image/05j.jpg","media_th_uri":"media/2008/August/still_image/tn_01aa.jpg","still_image_count":53,"moving_image_count":1,"textz_count":3,"soundz_count":1}},"pathContext":{"id":"contribution_430"}}

/***/ })

});


// WEBPACK FOOTER //
// path---issue-200808-still-image-32-04fca27cd58bda7acc10.js